var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseButtonView } from './BaseButtonView';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { checkColorType, Color } from '../../../Helpers';
import { getComponentColor } from '../../../Helpers/Hex/GetComponentColor';
import { useColorSchemeContext } from '../../Contexts/ThemeContext';
function style(props, primary_color, text_color) {
    let containerBackgroundColor = getComponentColor(primary_color || 'rgb(219, 0, 125)', props === null || props === void 0 ? void 0 : props.containerStyle, props === null || props === void 0 ? void 0 : props.light);
    const rgb = containerBackgroundColor
        .replace('rgb(', '')
        .replace('rgba(', '')
        .replace(')', '')
        .replace(' ', '')
        .split(',')
        .map(Number);
    const hoverBackgroundColor = new Color(rgb[0], rgb[1], rgb[2])
        .brightness(0.85)
        .toString();
    const pressBackgroundColor = new Color(rgb[0], rgb[1], rgb[2])
        .brightness(0.6)
        .toString();
    const disabledBackgroundColor = `rgba(${rgb.slice(0, 3).join(', ')}, 0.4)`;
    const textColor = checkColorType(containerBackgroundColor) === 'light'
        ? '#fff'
        : text_color || '#172A41';
    return {
        container: {
            backgroundColor: containerBackgroundColor
        },
        text: {
            color: textColor
        },
        hover: {
            backgroundColor: hoverBackgroundColor
        },
        pressed: {
            backgroundColor: pressBackgroundColor
        },
        inactive: {
            backgroundColor: 'rgba(184, 189, 199, 1)'
        },
        disabled: {
            backgroundColor: disabledBackgroundColor
        }
    };
}
export const PrimaryButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.primaryButton,
    style(theme, mediaQuery, window, props) {
        var _a, _b;
        return style(props, (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.primary_color, (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.text_color);
    }
})((_a) => {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var { defaultBackground, hoverBackground, pressBackground, inactiveBackground, disableBackground } = _a, props = __rest(_a, ["defaultBackground", "hoverBackground", "pressBackground", "inactiveBackground", "disableBackground"]);
    const color_scheme_context = useColorSchemeContext();
    if (color_scheme_context.scheme === 'dark' && props.light === undefined && props.style) {
        props.style = style(Object.assign(Object.assign({}, props), { light: true }));
    }
    return _jsx(BaseButtonView, Object.assign({}, props, { style: undefined, color: props.color || ((_c = (_b = props.style) === null || _b === void 0 ? void 0 : _b.text) === null || _c === void 0 ? void 0 : _c.color), textStyle: [(_d = props.style) === null || _d === void 0 ? void 0 : _d.text, props.textStyle], disabled: props.disabled || props.inactive, defaultBackground: defaultBackground || ((_f = (_e = props.style) === null || _e === void 0 ? void 0 : _e.container) === null || _f === void 0 ? void 0 : _f.backgroundColor), hoverBackground: hoverBackground || ((_h = (_g = props.style) === null || _g === void 0 ? void 0 : _g.hover) === null || _h === void 0 ? void 0 : _h.backgroundColor), pressBackground: pressBackground || ((_k = (_j = props.style) === null || _j === void 0 ? void 0 : _j.pressed) === null || _k === void 0 ? void 0 : _k.backgroundColor), inactiveBackground: inactiveBackground || ((_m = (_l = props.style) === null || _l === void 0 ? void 0 : _l.inactive) === null || _m === void 0 ? void 0 : _m.backgroundColor), disableBackground: disableBackground || ((_p = (_o = props.style) === null || _o === void 0 ? void 0 : _o.disabled) === null || _p === void 0 ? void 0 : _p.backgroundColor) }));
});
